import type { AssetDownPayment } from '@/modules/admin/resources'
import { APP_ROUTES } from '@/util/app-routes'

export function isDatePassed(date: string) {
  return new Date(date) < new Date()
}

export function getOrderIdPath(payment: AssetDownPayment) {
  return APP_ROUTES.HARDWARE_ECOM_POLICY_ORDER.replace(
    ':ecomPolicyOrderId',
    String(payment.ecomOrderId)
  )
}
